/* eslint-disable no-shadow */

export const FIELD_STATUS = {
  DISABLED: 'disabled',
  HIDDEN: 'hidden',
};

const state = {
  fields: [],
  error: null,
  updatePending: false,
  updateError: null,
  validationError: null,
};

const getters = {
  fields: (state) => state.fields,
  fieldStatus:
    (state) => (fieldName) => {
      const field = state.fields.find((f) => f.name === fieldName);
      if (!field) return '';

      if (field.isEnabled && field.isVisible) return '';
      if (field.isEnabled && !field.isVisible) return FIELD_STATUS.HIDDEN;
      if (!field.isEnabled && field.isVisible) return FIELD_STATUS.DISABLED;

      // both false
      return FIELD_STATUS.HIDDEN;
    },
};

const mutations = {
  clearErrors(state) {
    state.error = null;
    state.updateError = null;
    state.validationError = null;
  },
  setPageFields(state, { fields }) {
    state.fields = fields;
  },
  beforePageFieldsRequest(state) {
    state.fields = [];
  },
};

const actions = {
  updateFieldsForPage({ commit, rootGetters }, pageName) {
    const tree = rootGetters['user/property'].pageTree || [];
    const stack = [...tree];
    commit('beforePageFieldsRequest');
    while (stack.length) {
      const page = stack.pop();
      if (page.name === pageName) {
        const fields = (page.fields || []).map((field) => ({
          ...field,
          isEnabled: !field.isEnabled,
          isVisible: !field.isVisible,
        }));
        commit('setPageFields', { fields });
        break;
      }
      if (page.sub_pages?.length) {
        stack.push(...page.sub_pages);
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  FIELD_STATUS,
};
